import { token, host } from '../../Connnection';
import { toast } from 'react-toastify';

export default async function addTradeTerm(dataObject) {
    try {
        let res = await fetch(`${host}/api/TradeTerm`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataObject)
        })
        return await res.json();
    } catch (error) {
        console.log(error);
    }
}
